import { Component } from '@angular/core';
import { AlertDialogService } from '../../../services/alert-dialog.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  formGroup: FormGroup = this.fb.group({
    email: ['', Validators.required],
  });
  constructor(
    private alertDialog: AlertDialogService,
    private router: Router,
    private auth: AuthService,
    private fb: FormBuilder
  ) {}

  forgotPassword() {
    this.auth.fogetPassword(this.formGroup.value).subscribe((res) => {
      this.alertDialog
        .openAlertModal(
          'success',
          'Lien de réinitialisation envoyé',
          "Un lien pour réinitialiser votre mot de passe vous a été envoyé à l'adresse " +
            this.formGroup.get('email')?.value,
          'Retour à la page connexion',
          '',
          '',
          false,
          'assets/icons/check-circle.svg'
        )
        .subscribe((res) => {
          if (res) {
            this.router.navigate(['/login']);
          }
        });
    });
  }
}
